<template>
  <div class="home-view">
    <section class="-content">
      <div class="container">
        <h1 class="title-default">Guia do Cliente</h1>

        <ol>
          <li v-for="(item, i) in data" :key="item.id" :class="{ '-opened': item.isOpened }">
            <h3 @click="item.isOpened = !item.isOpened">{{ i + 1}}. {{ item.titulo }}</h3>

            <div class="content">
              <div v-html="item.conteudo"></div>
            </div> <!-- /.content -->
          </li> <!-- /li -->
        </ol>
      </div> <!-- /.container -->
    </section> <!-- /.-content -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'guia-do-cliente',

  data () {
    const data = {
      data: [],
      openedIds: []
    }

    return data
  }, // data()

  beforeMount () {
    this.load()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async load () {
      try {
        let xhr = await PagesService.getGuiacliente()
        xhr = xhr.reverse()

        this.data = xhr.filter(item => item.isAtivo).map(item => ({
          ...item,
          isOpened: true
        })).sort((a, b) => {
          if (a.ordem < b.ordem) return -1
          if (a.ordem > b.ordem) return 1
          return 0
        })
      } catch (e) {
        console.error('Falha ao carregar o conteúdo', e)
      }
    } // load()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  ol
    max-width: 800px
    width: 100%
    margin: 0 auto

    /deep/ li
      width: 100%
      margin-bottom: 20px

      *
        transition: all 250ms ease

      &.-opened
        h3
          color: map-get($colors, primary)
          border-color: map-get($colors, primary)

        .content
          max-height: 1000px
          height: auto

      h3
        border-bottom: 1px solid #000
        padding: 5px
        font-size: 22px
        cursor: pointer
        margin-bottom: 10px
        font-weight: 600

        &:hover
          color: map-get($colors, primary)
          border-color: map-get($colors, primary)

      .content
        max-height: 0
        overflow: hidden

        p
          margin-bottom: 10px
          font-size: 14px
          line-height: 23px

        strong
          font-weight: 700

        i
          font-style: italic
</style>
